import type { Migration, ApiMigration } from "../types/migrations";
import { formatDateSimple } from "./format-utils";

/**
 * Converts an API migration to the format required by the table
 * @param apiMigration API migration object
 * @returns Migration object formatted for the table
 */
export function mapApiMigrationToTableMigration(apiMigration: ApiMigration): Migration {
  const status = checkMigrationStatus(apiMigration);
  const startDate = formatDateSimple(apiMigration.lastMigrationExecution.timestamp);

  return {
    id: apiMigration.migrationId,
    projectName: apiMigration.name,
    startDate,
    endDate: startDate,
    status: mapStatusToUiStatus(status),
    migrationName: apiMigration.name,
  };
}

/**
 * Checks the migration status based on results
 * @param apiMigration API migration object
 * @returns Status string
 */
function checkMigrationStatus(apiMigration: ApiMigration): string {
  const hasFailed = apiMigration.migrationResult
    .filter((item) => item.excluded !== true)
    .some((item) => item.status !== "MIGRATED");
  return hasFailed ? "FAILED" : "MIGRATED";
}

/**
 * Maps API status values to UI status values
 * @param apiStatus API status string
 * @returns UI status string
 */
function mapStatusToUiStatus(apiStatus: string): string {
  const statusMap: Record<string, string> = {
    COMPLETED: "Done",
    DONE: "Done",
    FAILED: "Error",
    ERROR: "Error",
    IN_PROGRESS: "Ongoing",
    ONGOING: "Ongoing",
    PENDING: "Pending",
  };

  return statusMap[apiStatus.toUpperCase()] || apiStatus;
}
